export const NORMAL = 0
export const BOARD = 1
export const DUE_DATE = 2
